import VideoEditBlock, { VideoEditBlockProps } from './VideoEditBlock';
import withInteractor from './VideoEditBlock.interactor';
import withPresenter from './VideoEditBlock.presenter';

export type { VideoEditBlockProps };
export default withInteractor(withPresenter(VideoEditBlock));
